import { Badge, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { VlmServiceStatus } from '@/types/device'

type VlmStatusBadgeProps = {
  status: VlmServiceStatus | undefined
}

type StatusConfig = {
  color: string
  translationId: string
}

const STATUS_CONFIG: Record<VlmServiceStatus, StatusConfig> = {
  unknown: {
    color: 'gray',
    translationId: 'vlm.hardware.status.unknown'
  },
  initializing: {
    color: 'gray',
    translationId: 'vlm.hardware.status.initializing'
  },
  preparing: {
    color: 'blue',
    translationId: 'vlm.hardware.status.preparing'
  },
  starting_up: {
    color: 'blue',
    translationId: 'vlm.hardware.status.starting_up'
  },
  downloading_model: {
    color: 'blue',
    translationId: 'vlm.hardware.status.downloading_model'
  },
  running: {
    color: 'green',
    translationId: 'vlm.hardware.status.running'
  },
  degraded: {
    color: 'yellow',
    translationId: 'vlm.hardware.status.degraded'
  },
  stopped: {
    color: 'gray',
    translationId: 'vlm.hardware.status.stopped'
  },
  failed: {
    color: 'red',
    translationId: 'vlm.hardware.status.failed'
  }
}

export const VlmStatusBadge = ({ status }: VlmStatusBadgeProps) => {
  const config = STATUS_CONFIG[status ?? 'unknown']

  if (!config) {
    return (
      <Text size="sm" c="dimmed">
        {status}
      </Text>
    )
  }

  return (
    <Badge color={config.color}>
      <FormattedMessage id={config.translationId} />
    </Badge>
  )
}
